<template>
  <div style="padding:0 16px">
    <!-- 头部搜索区域 -->
    <div ref="search_d" style="display: flex;gap: 10px;padding-bottom: 10px;align-items: center;">
      <el-input style="width: 200px;" placeholder="请输入内容" v-model="queryInfo.condition.queryKey" clearable
        @keyup.enter="getList">
      </el-input>
      <el-button icon="el-icon-search"  type="primary" @click="getList">搜索</el-button>
      <el-button icon="el-icon-plus" type="primary" @click="newBtn">新建</el-button>
    </div>

    <div>
      <el-table border ref="table" v-loading="loading" :data="tableData" tooltip-effect="dark" style="width: 100%"
        :height="tableHeight" stripe :header-cell-style="{ background: 'rgb(238,241,246)' }">
        <el-table-column label="序号" type="index" width="50" align="center" fixed></el-table-column>

        <el-table-column label="平台名称" align="center" min-width="180" fixed>
          <template slot-scope="scope">
            <span style="overflow: hidden;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;color:#409eff;cursor:pointer;font-size: 13px;font-weight: 500;"
                  @click="edit(scope.row)">
                  {{ getFieldValue(scope.row, 'websiteName') }}
                  <i class="el-icon-edit-outline" style="margin-left:4px;"></i>
                </span>
          </template>
        </el-table-column>

        <el-table-column label="访问地址" align="center" min-width="100" fixed>
          <template slot-scope="scope">
            <el-button 
              icon="el-icon-link"
              style="padding: 0px 5px;font-size: 11px;"
              @click.stop="openNoticeUrl(scope.row.websiteUrl)"
            >
              打开链接
            </el-button>
          </template>
        </el-table-column>

        <el-table-column label="CA费用(元)" align="center" min-width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.caCost || '-' }}</span>
          </template>
        </el-table-column>

        <el-table-column label="注册公司" align="center" min-width="140">
          <template slot-scope="scope">
            <span style="overflow: hidden;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;">
                  {{ getFieldValue(scope.row, 'registerCompany') }}
                </span>
          </template>
        </el-table-column>

        <el-table-column label="登录名" align="center" min-width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.loginName || '-' }}</span>
          </template>
        </el-table-column>

        <el-table-column label="登录密码" align="center" min-width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.password || '-' }}</span>
          </template>
        </el-table-column>

        <el-table-column label="手机号" align="center" min-width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.contactPhone || '-' }}</span>
          </template>
        </el-table-column>

        <el-table-column label="联系人" align="center" min-width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.contactPerson || '-' }}</span>
          </template>
        </el-table-column>

        <el-table-column label="CA备注" align="center" min-width="160">
          <template slot-scope="scope">
            <span style="overflow: hidden;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;">
                  {{ getFieldValue(scope.row, 'caRemark') }}
                </span>
          </template>
        </el-table-column>

        <el-table-column label="网站类型" align="center" min-width="140">
          <template slot-scope="scope">
            <span>{{ getWebsiteTypeText(scope.row.websiteType) }}</span>
          </template>
        </el-table-column>

        <el-table-column label="创建时间" align="center" min-width="170">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime || '-' }}</span>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="90" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" icon="el-icon-delete" style="color: red;padding: 0;" @click="handleDelete(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!--分页-->
      <div style="padding-top:10px">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="queryInfo.currPage" :page-sizes="[100, 200, 300, 400]" :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>

    <!--弹窗表单-->
    <el-dialog :title="labelType == 'add' ? '新增招标平台' : '编辑招标平台'" :visible.sync="showDialog" width="800px">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px" style="padding: 20px 20px 0 20px;">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="平台名称" prop="websiteName">
              <el-input v-model="form.websiteName" placeholder="请输入平台名称">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="网站类型" prop="websiteType">
              <el-select v-model="form.websiteType" placeholder="请选择网站类型" style="width:100%">
                <el-option label="公共资源平台" value="0"></el-option>
                <el-option label="行业招标平台" value="1"></el-option>
                <el-option label="企业自建平台" value="2"></el-option>
                <el-option label="其他" value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="访问地址" prop="websiteUrl">
              <div style="display:flex;align-items:center;gap:10px;width:100%;">
                <el-input v-model="form.websiteUrl" placeholder="请输入访问地址"></el-input>
                <el-button type="primary" size="small" icon="el-icon-link"
                  @click="openNoticeUrl(form.websiteUrl)" :disabled="!form.websiteUrl">
                  打开链接
                </el-button>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="CA费用(元)" prop="caCost">
              <el-input-number v-model="form.caCost" :min="0" placeholder="CA费用(元)" style="width:100%"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="注册公司" prop="registerCompany">
              <el-input v-model="form.registerCompany" placeholder="请输入注册公司"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="登录名" prop="loginName">
              <el-input v-model="form.loginName" placeholder="请输入登录名"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="登录密码" prop="password">
              <el-input v-model="form.password" placeholder="请输入登录密码"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号" prop="contactPhone">
              <el-input v-model="form.contactPhone" placeholder="请输入手机号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系人" prop="contactPerson">
              <el-input v-model="form.contactPerson" placeholder="请输入联系人"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="CA备注" prop="caRemark">
              <el-input v-model="form.caRemark" placeholder="CA锁密码、登录说明"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="排序号" prop="sort">
              <el-input-number v-model="form.sort" :min="0" placeholder="排序号" style="width:100%"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showDialog = false">取消</el-button>
        <el-button type="primary" @click="handleSave">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      labelType: 'add',
      rules: {
        websiteName: [{ required: true, message: '请输入平台名称', trigger: 'blur' }],
        websiteUrl: [{ required: true, message: '请输入访问地址', trigger: 'blur' }],
      },
      total: 0,
      queryInfo: {
        pageSize: 100,
        pageCount: 1,
        currPage: 1,
        condition: {}
      },
      form: {},
      showDialog: false,
      tableData: [],
      tableHeight: window.innerHeight - 200,
      headerHeight: 0,
      loading: false
    };
  },
  created() {
    this.getList()
  },
  mounted() {
    this.$nextTick(() => {
      this.headerHeight = this.$refs.search_d.offsetHeight;
      window.addEventListener('resize', this.getHeight);
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getHeight);
  },
  methods: {
    // 计算表格高度
    getHeight() {
      this.tableHeight = window.innerHeight - this.headerHeight - 200;
    },

    openNoticeUrl(url) {
      if (!url) return
      // 新窗口打开
      window.open(url, '_blank')
    },

    // 获取列表
    getList() {
      const that = this;
      that.loading = true
      that.$http.post("/tenderWebsite/list", that.queryInfo).then(function (response) {
        if (response.data.code == 200) {
          that.total = response.data.data.count;
          that.queryInfo.currPage = response.data.data.currPage
          that.tableData = response.data.data.data;
        } else {
          that.$notify.info({ title: "提示", message: response.data.message, showClose: true });
        }
      }).catch(err => {
        that.$notify.error({ title: "异常", message: "请求列表失败", showClose: true });
      }).finally(() => {
        that.loading = false
      })
    },
    //保存
    handleSave() {
      const that = this;
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        that.$http.post("/tenderWebsite/save", that.form).then(function (response) {
          if (response.data.code == 200) {
            that.$notify.success({ title: "提示", message: "保存成功", showClose: true });
            that.showDialog = false
            that.getList()
          } else {
            that.$notify.info({ title: "提示", message: response.data.message, showClose: true });
          }
        }).catch(err => {
          that.$notify.error({ title: "异常", message: "保存接口异常", showClose: true });
        })
      })
    },
    //编辑
    edit(row) {
      this.showDialog = true;
      this.labelType = 'edit'
      this.form = JSON.parse(JSON.stringify(row))
    },
    // 删除
    async handleDelete(id) {
      const confirmResult = await this.$confirm("确定删除该招标平台吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).catch(err => err);
      if (confirmResult === "confirm") {
        const that = this;
        that.$http.post("/tenderWebsite/delete", { "id": id }).then(function (response) {
          if (response.data.code == 200) {
            that.$notify.success({ title: "提示", message: "删除成功", showClose: true });
            that.getList();
          } else {
            that.$notify.info({ title: "提示", message: response.data.message, showClose: true });
          }
        }).catch(err => {
          that.$notify.error({ title: "异常", message: "删除接口异常", showClose: true });
        })
      }
    },
    //新增
    newBtn() {
      this.labelType = 'add'
      this.form = {}
      // this.$refs.form.resetFields()
      this.showDialog = true;
    },
    //每页条数切换
    handleSizeChange(val) {
      this.queryInfo.pageSize = val;
      this.getList()
    },
    //页码切换
    handleCurrentChange(val) {
      this.queryInfo.currPage = val;
      this.getList()
    },
    // 网站类型文本转换
    getWebsiteTypeText(val) {
      const map = {
        '0': '公共资源平台',
        '1': '行业招标平台',
        '2': '企业自建平台',
        '3': '其他'
      }
      return map[val] ?? '-'
    },
    // popover 文本溢出公共方法，和投标项目页面统一
    getFieldValue(row, fieldCode) {
      return row[fieldCode] ?? '-'
    },
    getFullText(row, fieldCode) {
      return row[fieldCode] ?? ''
    },
    isTextOverflow(row, fieldCode) {
      const text = row[fieldCode]
      if (!text) return false
      return String(text).length > 16
    }
  },
};
</script>

<style lang="less" scoped>
/deep/ .custom-black-popover {
  background-color: #303133;
  color: #ffffff;
  white-space: pre-wrap;
  word-break: break-all;
}
/deep/ .custom-black-popover .popper__arrow {
  border-top-color: #303133 !important;
}
</style>
